import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import MyForm from './MyForm';

ReactDOM.render(
  <React.StrictMode>
    <MyForm />
  </React.StrictMode>,
  document.getElementById('root')
);

